import moment from "moment-timezone";
export const dateFormat = ({ date, timezone }) => {
  const actualDate = date instanceof Date ? date : new Date(date);

  const formattedDate = moment(actualDate)
    .tz(timezone)
    .format("DD MMMM, YYYY HH:mm:ss");
  return formattedDate;
};
